// extracted by mini-css-extract-plugin
module.exports = {"logoPlaceholder":"style__logoPlaceholder__qHeT9","returnToShift":"style__returnToShift__mWHQr"};